import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";
import { lovable } from "@/integrations/lovable";
import { supabase } from "@/integrations/supabase/client";

export const Route = createFileRoute("/auth")({
  head: () => ({
    meta: [
      { title: "Entrar — H2J Growth Company" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: AuthPage,
});

function AuthPage() {
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      if (data.session) navigate({ to: "/admin/blog" });
    });
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event) => {
      if (event === "SIGNED_IN") navigate({ to: "/admin/blog" });
    });
    return () => subscription.unsubscribe();
  }, [navigate]);

  const signIn = async () => {
    setError("");
    const { error: authError } = await lovable.auth.signInWithOAuth("google", {
      redirect_uri: `${window.location.origin}/auth`,
    });
    if (authError) setError("Não foi possível entrar. Tente novamente.");
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm border border-border bg-background p-8 text-center">
        <img
          src="/h2j-logo-340.webp"
          alt="H2J Growth Company"
          width={340}
          height={96}
          className="mx-auto h-10 w-auto"
        />
        <h1 className="mt-8 text-2xl font-semibold text-foreground">Área administrativa</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Entre com sua conta Google para gerenciar o blog.
        </p>
        <Button variant="premium" size="xl" className="mt-8 w-full" onClick={signIn}>
          Entrar com Google
        </Button>
        {error && <p className="mt-4 text-sm text-destructive">{error}</p>}
      </div>
    </main>
  );
}
